import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

export const SelectedClientBox = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: 8,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  transition: 'border-color 0.2s',
  '&:hover': { borderColor: theme.palette.text.secondary },
}));

export const SelectedAvatar = styled(Avatar)({
  width: 32,
  height: 32,
  fontSize: 13,
  fontWeight: 600,
});

export const ClearButton = styled(IconButton)({
  marginLeft: 'auto',
  opacity: 0.5,
  '&:hover': { opacity: 1 },
});

export const OptionRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

export const OptionAvatar = styled(Avatar)({
  width: 28,
  height: 28,
  fontSize: 12,
  fontWeight: 600,
});

export const NewBadge = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(0.75),
  paddingRight: theme.spacing(0.75),
  paddingTop: theme.spacing(0.125),
  paddingBottom: theme.spacing(0.125),
  borderRadius: 4,
  backgroundColor: theme.palette.warning.light,
  color: theme.palette.warning.dark,
  fontSize: 10,
  fontWeight: 700,
  lineHeight: 1.4,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
}));
